/* Yarn World dual-handle price slider (custom thumbs).
   Pointer-driven handles with live price bubbles; on release it writes
   Dawn's hidden min/max price fields and fires their input event so
   Dawn's AJAX filtering applies. All listeners are delegated at the
   document level, so facet re-renders never orphan the slider. */
(function () {
  var drag = null; // { slider, thumb, kind }

  function parts(slider) {
    var priceRange = slider.closest('price-range') || slider.parentElement;
    var fields = priceRange ? priceRange.querySelectorAll('.field__input') : [];
    return {
      tMin: slider.querySelector('.yw-price-slider__thumb--min'),
      tMax: slider.querySelector('.yw-price-slider__thumb--max'),
      fieldMin: fields[0],
      fieldMax: fields[1],
      top: parseInt(slider.getAttribute('data-max'), 10) || 1,
      sym: slider.getAttribute('data-symbol') || '$'
    };
  }

  function paint(slider) {
    var p = parts(slider);
    var lo = parseInt(p.tMin.getAttribute('data-value'), 10);
    var hi = parseInt(p.tMax.getAttribute('data-value'), 10);
    slider.style.setProperty('--yw-min', (lo / p.top) * 100 + '%');
    slider.style.setProperty('--yw-max', (hi / p.top) * 100 + '%');
    p.tMin.setAttribute('aria-valuenow', lo);
    p.tMax.setAttribute('aria-valuenow', hi);
    var bMin = p.tMin.querySelector('.yw-price-slider__bubble');
    var bMax = p.tMax.querySelector('.yw-price-slider__bubble');
    if (bMin) bMin.textContent = p.sym + lo;
    if (bMax) bMax.textContent = p.sym + hi + (hi >= p.top ? '+' : '');
  }

  function setValue(slider, kind, value) {
    var p = parts(slider);
    var lo = parseInt(p.tMin.getAttribute('data-value'), 10);
    var hi = parseInt(p.tMax.getAttribute('data-value'), 10);
    value = Math.max(0, Math.min(p.top, Math.round(value)));
    if (kind === 'min') {
      value = Math.min(value, hi);
      p.tMin.setAttribute('data-value', value);
    } else {
      value = Math.max(value, lo);
      p.tMax.setAttribute('data-value', value);
    }
    paint(slider);
  }

  function commit(slider, kind) {
    var p = parts(slider);
    if (!p.fieldMin || !p.fieldMax) return;
    var lo = parseInt(p.tMin.getAttribute('data-value'), 10);
    var hi = parseInt(p.tMax.getAttribute('data-value'), 10);
    p.fieldMin.value = lo > 0 ? lo : '';
    p.fieldMax.value = hi < p.top ? hi : '';
    var target = kind === 'min' ? p.fieldMin : p.fieldMax;
    target.dispatchEvent(new Event('input', { bubbles: true }));
  }

  function valueFromPointer(slider, clientX) {
    var rail = slider.querySelector('.yw-price-slider__rail');
    var rect = rail.getBoundingClientRect();
    var frac = (clientX - rect.left) / rect.width;
    return Math.max(0, Math.min(1, frac)) * (parseInt(slider.getAttribute('data-max'), 10) || 1);
  }

  document.addEventListener('pointerdown', function (e) {
    var thumb = e.target.closest && e.target.closest('.yw-price-slider__thumb');
    if (!thumb) return;
    e.preventDefault();
    var slider = thumb.closest('.yw-price-slider');
    drag = {
      slider: slider,
      thumb: thumb,
      kind: thumb.classList.contains('yw-price-slider__thumb--min') ? 'min' : 'max'
    };
    slider.querySelectorAll('.yw-price-slider__thumb').forEach(function (t) {
      t.classList.remove('is-active');
    });
    thumb.classList.add('is-active');
    try { thumb.setPointerCapture(e.pointerId); } catch (err) {}
  }, true);

  document.addEventListener('pointermove', function (e) {
    if (!drag) return;
    setValue(drag.slider, drag.kind, valueFromPointer(drag.slider, e.clientX));
  }, true);

  function endDrag() {
    if (!drag) return;
    commit(drag.slider, drag.kind);
    drag = null;
  }
  document.addEventListener('pointerup', endDrag, true);
  document.addEventListener('pointercancel', endDrag, true);

  /* keyboard support on focused thumbs */
  document.addEventListener('keydown', function (e) {
    var thumb = e.target.closest && e.target.closest('.yw-price-slider__thumb');
    if (!thumb) return;
    var step = { ArrowLeft: -1, ArrowDown: -1, ArrowRight: 1, ArrowUp: 1 }[e.key];
    if (!step) return;
    e.preventDefault();
    var slider = thumb.closest('.yw-price-slider');
    var kind = thumb.classList.contains('yw-price-slider__thumb--min') ? 'min' : 'max';
    var cur = parseInt(thumb.getAttribute('data-value'), 10);
    setValue(slider, kind, cur + step);
    clearTimeout(thumb._ywCommit);
    thumb._ywCommit = setTimeout(function () { commit(slider, kind); }, 600);
  }, true);

  /* click on the rail jumps the nearest thumb */
  document.addEventListener('click', function (e) {
    var rail = e.target.closest && e.target.closest('.yw-price-slider__rail');
    if (!rail) return;
    var slider = rail.closest('.yw-price-slider');
    var p = parts(slider);
    var v = valueFromPointer(slider, e.clientX);
    var lo = parseInt(p.tMin.getAttribute('data-value'), 10);
    var hi = parseInt(p.tMax.getAttribute('data-value'), 10);
    var kind = Math.abs(v - lo) <= Math.abs(v - hi) ? 'min' : 'max';
    setValue(slider, kind, v);
    commit(slider, kind);
  }, true);
})();
